import { render, staticRenderFns } from "./QLong.vue?vue&type=template&id=6edbf70f&scoped=true&"
import script from "./QLong.vue?vue&type=script&lang=js&"
export * from "./QLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbf70f",
  null
  
)

export default component.exports